<template>
<div v-if="survey_check">
	<div class="wrapper">
		<div id="breadCrumb" class="col content pt-2">
			<router-link :to="{ name: 'therapy' }" class="smooth-menu">{{ $t('courses.header')}}</router-link> >
			<router-link v-if="enrollment" :to="{ name: 'therapy.display', params: {enrol_id: enrol_id} }" class="smooth-menu">{{enrollment.program.display_name}}</router-link> >
			<span v-if="stage.name">{{ stage.name }}</span>
		</div>
	</div>

	<div class="wrapper">
		<SideBar @programRoute="onProgramRouteClick" v-if="task_id > 0" :task_id="task_id" ></SideBar>

		<!-- router-view :key="routeKey"></router-view -->
		<TherapyContent v-if="task_id > 0" :key="routeKey" :task_id="task_id" :page_position="furthest_position" />
	</div>

</div>
</template>

<script>
import { mapActions } from 'vuex'

import { EventBus, mapNotificationEventActions } from '@/lib/events.js';
import { mapCommonFilters } from '@/lib/filters.js';
import { errHandler } from '@/lib/handlers';
import { mapDebugActions } from '@/lib/debug';

import moment from 'moment';

export default {
	name: 'TherapyStage',
	components: {
		SideBar: () => import('@/components/SideBar.vue'),
		TherapyContent: () => import('@/views/therapy/TherapyContent.vue')
	},
	data () {
		return {
			routeKey: 0,
			task_id: 0,
			survey_check: false,
			position: null
		}
	},
	watch: {
		$route: function() {
			this.checkTask();
		},
	},
	created () {

		this.position = this.$route.query.position;
		this.fetchSurveys(this.enrollment.id).then((res) => {
			if(this.surveys.length) {
				this.$router.push({ name: 'therapy.display', params: { enrol_id: this.enrol_id } });
			} else {
				this.survey_check = true;
			}
		})
		
	},
	mounted () {
		this.checkTask();
	},
	computed: {
		enrol_id () {
			return this.$route.params.enrol_id;
		},
		stage_id () {
			return this.$route.params.stage_id;
		},
		task_id_route () {
			return this.$route.params.task_id;
		},
		enrollment () {
			return this.$store.state.programs.enrollment;
		},
		stage () {
			if (this.$store.state.programs.stage) return this.$store.state.programs.stage;
		},
		surveys () {
			return (this.$store.state.surveys.surveys) ? _.orderBy(this.$store.state.surveys.surveys, 'position', 'asc') : {};
		},
		furthest_position () {
			return this.position;
		}
	},
	methods: {
		...mapActions(['fetchSurveys']),
		...mapDebugActions,
		onProgramRouteClick () { // Forces the Content to Refresh when Side Nav item is clicked
			this.routeKey++;
		},
		checkTask () {

			let task = (this.task_id_route) ? this.$store.state.programs.stage.tasks[this.task_id_route] : null;
			let tasks = _.orderBy(this.$store.state.programs.stage.tasks, 'position', 'asc');

			this.debugObject({task, tasks, task_id: this.task_id_route});

			if (task == undefined || task.unlocked == false) {
				if (tasks) {
					task = tasks[0]
				}

				if (task == undefined || task.unlocked == false) {
					this.$router.push({ name: 'therapy.display', params: { enrol_id: this.enrol_id } });
					return;
				}
			}

			this.task_id = task.id;

			this.debugObject({task, tasks, task_id: this.task_id});

		}
	}
}
</script>
